import * as React from "react";
import pureRender from "pure-render-deepcompare-decorator";
import * as classnames from "classnames";
import * as styles from "./Dialog.scss";
import * as subpub from "../../utils/subpub";
import { fetchNickname } from "../../utils/fetch";


export interface IDialogProps{
    /**class */
    className?:string;
    curBindYyuid:number|string;
    shareYyuid:number;
    contTips:string
}
export interface IDialogState{
    curBindNickName:string;
    shareNickName:string;
}
@pureRender
export class Dialog extends React.Component<IDialogProps,IDialogState>{
    constructor(props){
        super(props);
        this.state={
            curBindNickName:"",
            shareNickName:""
        }
    }
    componentWillMount(){
        if(!!this.props.curBindYyuid){

            fetchNickname(this.props.curBindYyuid)
            .then((res:any)=>{
                this.setState({
                    curBindNickName:res.data
                })
            })
        }
        fetchNickname(this.props.shareYyuid)
        .then((res:any)=>{
            this.setState({
                shareNickName:res.data
            })
        })
        
    }
    public render(){
        // const {className} =this.props;
        // const classNameSec=classnames(styles.sec,className);
        const{curBindNickName,shareNickName}=this.state;
        const {curBindYyuid,shareYyuid,contTips}=this.props;
        return (
            <div className={styles.sec}>
                {this.renderTemp(curBindYyuid,shareYyuid,contTips,curBindNickName,shareNickName)}
            </div>
        )
    }

    // 渲染模板
    private renderTemp(curBindYyuid,shareYyuid,contTips,curBindNickName,shareNickName){
        if(!!curBindYyuid){
            return this.changeBindTemp(curBindYyuid,shareYyuid,contTips,curBindNickName,shareNickName)
        }else{
            return this.bindTemp(shareYyuid,contTips,shareNickName)
        }        
    }

    // 渲染改绑模板
    private changeBindTemp(curBindYyuid,shareYyuid,contTips,curBindNickName,shareNickName){
        contTips=contTips.replace(shareYyuid, shareNickName);
        return(
            <div>
            <div className={styles.changebind_box}>
                <div className={styles.user_info}>
                    <p className={styles.info_tips}>
                        当前绑定
                    </p>
                    <div className={styles.user_img}>
                        <img src={"http://image.open.yy.com/avatar/"+curBindYyuid} alt="" width="66" height="66"/>
                        <div className={styles.img_mask}></div>
                    </div>
                    <div className={styles.user_name}>{curBindNickName}</div>
                </div>
                <div className={styles.change_arrow}></div>
                <div className={styles.user_info}>
                    <p className={styles.info_tips}>
                        新绑定
                    </p>
                    <div className={styles.user_img}>
                        <img src={"http://image.open.yy.com/avatar/"+shareYyuid} alt="" width="66" height="66"/>
                        <div className={styles.img_mask}></div>
                    </div>
                    <div className={styles.user_name}>{shareNickName}</div>
                </div>
            </div>
            <div className={styles.tips}>
                
                    {contTips}
                </div>
            </div>
        )
    }


// 渲染绑定模板
    private bindTemp(shareYyuid,contTips,shareNickName){
        contTips=contTips.replace(shareYyuid, shareNickName);
        return(
        
        <div className={styles.bind_box}>
            <div className={styles.user_info}>
                
                <div className={styles.user_img}>
                    <img src={"http://image.open.yy.com/avatar/"+shareYyuid} alt="" width="66" height="66"/>
                    <div className={styles.img_mask}></div>
                </div>
                <div className={styles.user_name}>{shareNickName}</div>
            </div>
            <div className={styles.bind_tips}>
                {contTips}
            </div>
            
            
        </div>
        )
    }
    
    
}

export default Dialog;


// WEBPACK FOOTER //
// ./src/components/Dialog/Dialog.tsx